import { Dispatch } from "redux";
import {
  NotificationAction,
  RESET_NOTIFICATION,
  SET_NOTIFICATION,
} from "../types/notification.types";
import { NotificationTypeEnum } from "common/enums/NotificationTypeEnum";
import { i18nUserContext } from "config/translations/I18n";

/** ---- DISPATCHERS ---- */
export const dispatchOffline = () => {
  return (dispatch: Dispatch<NotificationAction>) => {
    dispatch({
      type: SET_NOTIFICATION,
      payload: {
        type: NotificationTypeEnum.ERROR,
        message: i18nUserContext.t("notification.message.checkConnection"),
      },
    });
  };
};

export const dispatchHelenaNotRegistered = () => {
  return (dispatch: Dispatch<NotificationAction>) => {
    dispatch({
      type: SET_NOTIFICATION,
      payload: {
        type: NotificationTypeEnum.WARNING,
        message: i18nUserContext.t("notification.message.helenaNotRegistered"),
      },
    });
  };
};

export const dispatchResetNotification = () => {
  return (dispatch: Dispatch<NotificationAction>) => {
    dispatch({ type: RESET_NOTIFICATION });
  };
};

export const dispatchError = (errorMessage: string, correlationId?: string) => {
  return (dispatch: Dispatch<NotificationAction>) => {
    dispatch({
      type: SET_NOTIFICATION,
      payload: {
        type: NotificationTypeEnum.ERROR,
        message: errorMessage,
        correlationId: correlationId,
      },
    });
  };
};

export const resetNotification = (keepNotification?: boolean) => {
  if (!keepNotification) {
    return (dispatch: Dispatch<NotificationAction>) => {
      return dispatch({
        type: RESET_NOTIFICATION,
      });
    };
  }
};
